<template>
  <div class="subs topics-group">
    <subscription-topic-header-row 
        @changenotification="changeNotification" 
        :notificationProp="notifyAll"
        :isOpen="isOpen"
        @immediateChanged="immediateChanged" 
        @dailyChanged="dailyChanged" 
        @toggleOpen="toggleOpenHeader"
        @weeklyChanged="weeklyChanged"/>
    <div v-if="profileBoardsCategories != null && topicSettings && showRows" :class="showContentClass">
      <!-- <subscription-topic-row @refreshdata="refreshdata" v-for="cat in profileBoardsCategories" :key="cat.id" :boardCat="cat" :emailSettings="topicSettings"/> -->
      <subscription-topic-board-category @refresh="refresh" @refreshEmail="refreshEmail"
        v-for="boardCat in profileBoardsCategories" :key="boardCat.boardCategoryName" :boardCategory="boardCat" :emailSettings="topicSettings"/> 
    </div>
  </div>
</template>

<script>
import SubscriptionTopicHeaderRow from './SubscriptionTopicHeaderRow.vue';
import SubscriptionTopicBoardCategory from "./SubscriptionTopicBoardCategory.vue";
import SubscriptionTopicRow from './SubscriptionTopicRow.vue';
import api from '../../../api/api';

export default {
  components: {SubscriptionTopicHeaderRow, SubscriptionTopicRow, SubscriptionTopicBoardCategory},
  props: ["topicsBoardCat"],
  data() {
    return {
      profileBoardsCategories: [],
      topicSettings: null,
      showRows: true,
      isOpen: false,
    }
  },
  created() {
    this.profileBoardsCategories = this.topicsBoardCat;
     api.get('/Communication/topics').then(r => {
      this.topicSettings = r.data;
    });
  },
  watch: {
    topicsBoardCat(newValue) {
      this.profileBoardsCategories = newValue;
    },
  },
  methods: {
    refresh() {
      this.$emit("refresh");
    },
    refreshEmail() {
      api.get('/Communication/topics').then(r => {
        this.topicSettings = r.data;
        this.$forceUpdate();
      });
    },
    toggleOpenHeader() {
        this.isOpen = !this.isOpen;
    },
    changeNotification(e) {
      api.post('/Subscription/topics/bulk', {
        subscribeAll: e
      }).then(() => {
        api.get('/Subscription/topics').then(() => {
          
        });
      });
    },
    refreshdata() {
      // api.get('/Subscription/topics').then((r) => {
      //   // Set the array to null before setting it again to another array to overcome vue bug (did not handle the changes and the new content was not rendered)
      //   this.profileTopics = null;
      //   this.profileTopics = r.data;
      // });
    },
    getEmailSettingForTopic(topicID){
      if(!this.topicSettings){
        return null;
      }
      return this.topicSettings.find(x => x.topicId == topicID);
    },
    immediateChanged(e) {
      api.post('/Communication/topics/bulk', {
        Immediate: e,
      }).then(() => {
        api.get('/Communication/topics').then(r => {
          this.showRows = false;
          this.topicSettings = null;
          this.topicSettings = r.data;
          this.$nextTick(() => {
            this.showRows = true;
          });
        });
      });
    },
    dailyChanged(e) {
      api.post('/Communication/topics/bulk', {
        Daily: e,
      }).then(() => {
        api.get('/Communication/topics').then(r => {
          this.showRows = false;
          this.topicSettings = null;
          this.topicSettings = r.data;
          this.$nextTick(() => {
            this.showRows = true;
          });
        });
      });
    },
    weeklyChanged(e) {
      api.post('/Communication/topics/bulk', {
        Weekly: e,
      }).then(() => {
        api.get('/Communication/topics').then(r => {
          this.showRows = false;
          this.topicSettings = null;
          this.topicSettings = r.data;
          this.$nextTick(() => {
            this.showRows = true;
          });
        });
      });
    },
  },
  computed: {
    notifyAll() {
      return false;
    },
    showContentClass() {
        return {
            'subscription-board-rows': !this.isOpen,
            'subscription-board-rows-opened': this.isOpen
        }
    },
  }
}
</script>

